export default __webpack_public_path__ + "static/media/cardano.d11358fa.svg";